<template>
  <el-dialog
    width="45%"
    title="Информация для формирования отчета"
    class="dialog--save-nomenclature"
    :before-close="closeModal"
    :visible.sync="visible"
    append-to-body
    @open="openModal"
  >
    <el-form ref="form" :model="formData">
      <el-row :gutter="24">
        <el-col :span="16">
          <el-form-item label="Номенклатура">
            <el-input v-model="formData.cargo" size="mini" autocomplete="off" />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="Номер отчета">
            <el-input
              v-model="formData.number"
              size="mini"
              autocomplete="off"
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="Маршрут">
            <el-input v-model="formData.route" size="mini" autocomplete="off" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <div>
        <el-button
          type="primary"
          :disabled="progressBar.is"
          @click="onSaveNomenclatureHandler"
        >
          Сформировать
        </el-button>
      </div>
      <div v-if="progressBar.start" class="progress-bar--container">
        <div class="progress-bar--text">
          Скачивание начнется автоматически сразу после формирования отчета на
          сервере.

          <div v-if="statusDownload === 'ready'">
            <span class="bold">
              Отчет сформирован. Если скачивание не началось автоматически.
              Перейдите по ссылке.
            </span>
            <a target="_blank" :href="linkDownload">{{ linkDownload }}</a>
          </div>
          <div v-if="statusDownload !== 'ready'">
            Если файл не смог сформироваться полностью, нажмите эту
            <el-link type="danger" @click.native="reloadDownloadReport">
              ссылку
            </el-link>
            для переформироваться
          </div>
        </div>

        <progress-bar
          v-if="progressBar.is"
          color="#67C23A"
          :time="10000"
          :start="true"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { ADD_REPORT, FETCH_REPORT, GET_REPORT } from '@/store/actions/shipping'
import { SET_PROGRESS_BAR, SET_STATUS_DOWNLOAD } from '@/store/actions/reports'
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/ProgressBar/ProgressBar'

export default {
  name: 'FormSaveNomenclature',
  components: { ProgressBar },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    curBid: {
      type: Number,
      default: null,
    },
    linkDownload: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formData: {
        cargo: '',
        number: '',
        route: '',
      },
      progressBar: {
        is: false,
        start: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      report: 'reports/getCurrentReport',
    }),
    statusDownload: {
      get() {
        return this.$store.getters[`reports/getStatusDownload`]
      },
      set(value) {
        this.$store.dispatch(`reports/${SET_STATUS_DOWNLOAD}`, value)
      },
    },
  },
  watch: {
    statusDownload() {
      if (this.statusDownload === 'ready') {
        this.progressBar.is = false
        this.$store.dispatch(`reports/${SET_PROGRESS_BAR}`, 0)
      } else if (this.statusDownload === 'error') {
        this.progressBar.is = false
      }
    },
  },
  methods: {
    onSaveNomenclatureHandler() {
      this.statusDownload = ''
      const payload = {
        id: this.curBid,
        item: {
          cargo: this.formData.cargo,
          number: this.formData.number,
          route: this.formData.route,
        },
        scoupe: ['report'],
      }

      this.$store.dispatch(`shipping/${ADD_REPORT}`, payload).then(() => {
        this.$emit('save', payload)
        this.progressBar.is = true
        this.progressBar.start = true
      })
    },
    openModal() {
      this.$store.dispatch(`shipping/${FETCH_REPORT}`, {
        cargo: this.report.cargo,
        number: this.report.number,
        route: this.report.route,
      })
      const { cargo, number, route } =
        this.$store.getters[`shipping/${GET_REPORT}`]

      this.formData = {
        ...this.formatDate,
        cargo,
        number,
        route,
      }
    },
    closeModal() {
      this.progressBar.is = false
      this.progressBar.start = false
      this.formData.nomenclature = ''
      this.$emit('close')
    },
    reloadDownloadReport() {
      this.onSaveNomenclatureHandler()
    },
  },
}
</script>

<style lang="sass">

.progress-bar
  &--container
    margin-top: 50px
    margin-bottom: 20px
    text-align: left

  &--text
    margin-bottom: 10px
    text-align: left
    font-size: 16px
    line-height: 24px

    & span
      margin-top: 10px
      margin-bottom: 10px
      display: block

      &.bold
        font-weight: 700

    & a
      color: #409EFF
      text-decoration: underline

    & .text-red
      color: #FF0000

.dialog-footer
  width: 100%

.dialog--save-nomenclature
  font-family: 'Rubik', sans-serif
  & .el-checkbox
    font-weight: 300
    &__label
      font-size: 16px
      line-height: 1.8
</style>
